import { createSlice } from '@reduxjs/toolkit'

interface AppSliceInitialState {
  mapDataDrawer: {
    open: boolean
  }
  howItWorksModal: {
    open: boolean
  }
  waterCoreSnapscoreModal: {
    open: boolean
  }
  shareResultsModal: {
    open: boolean
  }
  isSharedView: boolean
}

const initialState: AppSliceInitialState = {
  mapDataDrawer: {
    open: false,
  },
  howItWorksModal: {
    open: false
  },
  waterCoreSnapscoreModal: {
    open: false
  },
  shareResultsModal: {
    open: false
  },
  isSharedView: false
}


export const appSlice = createSlice({
  name: 'appSlice',
  initialState,
  reducers: {
    setMapDataDrawerOpen: (state, action) => {
      state.mapDataDrawer.open = action.payload;
    },
    setHowItWorksModalOpen: (state, action) => {
      state.howItWorksModal.open = action.payload;
    },
    toggleHowItWorksModalOpen: (state) => {
      state.howItWorksModal.open = !state.howItWorksModal.open;
    },
    toggleWaterCoreSnapscoreModal: (state) => {
      state.waterCoreSnapscoreModal.open = !state.waterCoreSnapscoreModal.open;
    },
    toggleShareResultsModal: (state) => {
      state.shareResultsModal.open = !state.shareResultsModal.open;
    },
    setSharedView: (state, action) => {
      state.isSharedView = action.payload;
    }
  },
  extraReducers: (builder) => {},
})

export const AppActions = {
  ...appSlice.actions,
}

export const AppReducer = appSlice.reducer
